import Container from '@material-ui/core/Container'
import LinearProgress from '@material-ui/core/LinearProgress'
import Alert from '@material-ui/lab/Alert'
import React from 'react'

export function FullPageSpinner() {
  return (
    <Container>
      <LinearProgress />
    </Container>
  )
}

export function FullPageErrorFallback({ error }) {
  return (
    <Container>
      <p>Uh oh... There's a problem. Try refreshing the app.</p>
      <Alert severity="error">{error.message}</Alert>
    </Container>
  )
}
